import React, { useEffect } from "react";

import globalState from "../../features/global-state";

import { Box, Paper } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";

import { IPropostaState, downloadProposta, reenviarPropostaSigas, gotoFaseProposta } from "../../features/simulacao/proposta";
import { mostraDeDateISOparaDataPtBr } from "@refere/ui-utils/ui/utils/format";

import SummaryBox from "../component/SummaryBox";
import { useHookstate } from "@hookstate/core";

export interface IPropostasProps {
    proposta?: IPropostaState
}

// Equivalente ao Container xl
const containerSx = {
    width: "100%",
    maxWidth: 1200,
    mx: "auto",
    px: 2,
};

// Equivalente ao Row
const rowSx = {
    display: "flex",
    flexWrap: "wrap",
    mx: -2,
};

// Equivalente ao Col
const colSx = {
    flex: "1 0 0%",
    px: 2,
    maxWidth: "100%",
};

const Propostas = () => {
    const propostaState = useHookstate(globalState.faseProposta);

    useEffect(() => {
        gotoFaseProposta();
        // eslint-disable-next-line
    }, []);

    const temPropostaComErro = propostaState?.simulacaoesProposta?.get().some(sp => !sp.enviadaParaConcentrador) ?? false;

    return (
        <>
            {
                typeof propostaState?.simulacaoesProposta.get() !== "undefined" &&
                <>
                    <SummaryBox />
                    <Paper sx={{ mt: "20px", ml: "15px", mr: "15px" }}>
                        {(propostaState.simulacaoesProposta?.get().length === 0 || temPropostaComErro) &&
                            <Box sx={containerSx}>
                                <Box sx={{ ...rowSx, pb: 3, pt: 3 }}>
                                    <Box sx={colSx}>
                                        <Alert severity="warning">
                                            {
                                                temPropostaComErro
                                                ? "Ocorreu um erro no retorno da proposta da MAG, a proposta foi efetivada mas não foi possível enviar a efetivação para o SIGAS. Caso não retorne registro de proposta para o segurado no SIGAS em até 24h, entre em contato com a corretora com os dados do segurado e cotação para validação."
                                                : "Ocorreu um erro no retorno da proposta da MAG, não foi possível enviar a efetivação para o SIGAS. entre em contato com a corretora com os dados do segurado e cotação para validação."
                                            }
                                        </Alert>
                                    </Box>
                                </Box>
                            </Box>
                        }

                        {propostaState.simulacaoesProposta.get().map((p, index) => (
                            <Box key={index} sx={containerSx}>
                                <Box sx={{ ...rowSx, paddingTop: "10px" }}>
                                    <Box sx={colSx}>
                                        <Typography variant="h4" style={{ color: "black" }} className="mt-3 mb-2" >Proposta Efetivada!</Typography>
                                        <Typography variant="h6">Proposta gerada na seguradora: <span style={{ fontSize: "1.0rem" }}>{p.numeroProposta}</span></Typography>
                                        <Typography variant="h6">Status da Proposta: <span style={{ fontSize: "1.0rem" }}>{p.status}</span></Typography>
                                        <Typography variant="subtitle1">Envio: {p.dtEnvio ? mostraDeDateISOparaDataPtBr(p.dtEnvio) : ""}</Typography>
                                    </Box>
                                </Box>

                                {p.mensagemDownloadProposta &&
                                    <Alert severity="warning">{p.mensagemDownloadProposta}</Alert>
                                }

                                <Box sx={{ ...rowSx, mt: 3, pb: 3 }}>
                                    <Box sx={colSx}>
                                        <Button variant="contained" color="primary"
                                            onClick={() => downloadProposta(index, p.idSimulacao)}>
                                            Imprimir Proposta
                                        </Button>
                                    </Box>
                                </Box>

                                {!p.enviadaParaConcentrador &&
                                    <Box sx={{ ...rowSx, mt: 3, pb: 3 }}>
                                        <Box sx={colSx}>
                                            <Alert severity="warning"
                                                action={
                                                    <Button color="inherit" size="small" className="removeCapitalize" onClick={() => reenviarPropostaSigas(index)}>
                                                        Reenviar Proposta para o Sigas.
                                                    </Button>
                                                }
                                            >
                                                Houve uma falha na integração com o SIGAS.
                                            </Alert>
                                        </Box>
                                    </Box>
                                }
                            </Box>
                        ))}
                    </Paper>
                </>
            }
        </>
    );
};

export default Propostas;